import { Ring } from '@blocks/Loading'
import usePhotoController from '@customer/api/usePhotoController'
import { notify } from '@helpers'
import useLoading from '@hooks/useLoading'
import { ReactComponent as EditIcon } from '@icons/edit.svg'
import { colors } from '@styles/vars'
import { debounce } from 'lodash'
import React, { useCallback } from 'react'
import styled from 'styled-components'

export default function PhotoTitle({ photo, onChange }: Props) {
    const controller = usePhotoController()
    const loading = useLoading()

    const handler = useCallback(debounce(async (title: string) => {
        await loading.until(async () => {
            const response = await controller.update(photo.id, { title })
            await onChange(response)
        })

        notify("Photo: we successfuly updated the title.", undefined, undefined, 3000)
    }, 800), [])
    
    const handleTitleChange: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
        if (!e.target.value) return
        await handler(e.target.value)
    }

    return (
        <TitleWrapper>
            <TitleInput id={`title-${photo.id}`} defaultValue={photo.title} onChange={handleTitleChange} />
            <label htmlFor={`title-${photo.id}`}>{loading.state ? <Ring fill={colors.white} /> : <EditIcon />}</label>
        </TitleWrapper>
    )
}

const TitleWrapper = styled.div`
    display: flex;
    width: 100%;
    position: relative;
    height: 36px;

    label {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        top: 0;
        flex-shrink: 0;
        right: 0;
        width: 42px;
        height: 100%;
        background: hsla(0, 0%, 100%, 0.2);
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border: 1px solid hsla(0, 0%, 100%, 0.2);

        svg {
            width: 20px;
            height: 20px;
        }
    }
`

const TitleInput = styled.input`
    width: 100%;
    background: transparent;
    font-size: 20px;
    font-weight: 600;
    color: ${colors.white};
    padding: 10px;
    height: 36px;
    border-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    transition: .4s ease-out;
    border: 1px solid hsla(0, 0%, 100%, .2);
    border-right: 0;
    background: hsla(0, 0%, 100%, .1);
    text-overflow: ellipsis;

    &:focus {
        outline: none;
    }
`

interface Props {
    photo: Interfaces.Photo
    onChange: (photo: Interfaces.Photo) => Promise<void>
}